import { fromJS } from 'immutable';

const initialState = fromJS({});

function plansPageReducer(state = initialState) {
  return state;
}

export default plansPageReducer;
